// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__uoiVC","m":"styles_m__pGzi4","check":"styles_check__znR7G","checkedMarker":"styles_checkedMarker__7Z7VE","icon":"styles_icon__UWtnZ"};